import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const formContainerV4Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Form Container element to v4 by releasing the AI field-generation latch',
  run: (props: PartialPropsOf<'formContainer'>): void => {
    delete props.content?.aiGeneratedFields;
  },
};
